import { useEffect, useState } from "react";
import { FiShoppingCart } from "react-icons/fi";
import { CiUser } from "react-icons/ci";
import { IoIosArrowDown } from "react-icons/io";
import { GiHamburgerMenu } from "react-icons/gi";
import { GridContainer } from "../../global";
import { ButtonIntegrador, ButtonMenuMobile, CallToAction, HeaderContainer, Logo, Navigation } from "./style";

export function Header() {
   
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [isOpenMenu, setIsOpenMenu] = useState(false);

    
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

       
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); 


    const handleMenuMobile = () => {
        setIsOpenMenu(!isOpenMenu);
    };

    return (
        <div style={{ width: "100%", position: "relative" }}>
            <GridContainer>
                <HeaderContainer>
                    <a href="/"><Logo src="/logo-renovera.png" /></a>
                    <Navigation controlMenu={isOpenMenu ? "block" : "none"}>
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><a href="/quemsomos">Quem Somos</a></li>
                            <li><a href="/Blog">Blog</a></li>
                            <li><a href="/faq">FAQ</a></li>
                            <li><a href="/fale-conosco">Contato</a></li>
                            <li><a href="/LGPD">LGPD</a></li>
                         
                            {screenWidth <= 480 && (
                                <li><ButtonIntegrador href="https://integrador.renovera.com.br/" target="blank_"><CiUser size={16} /> Área do integrador <IoIosArrowDown /></ButtonIntegrador></li>
                            )}
                        </ul>
                    </Navigation>
                 
                    {screenWidth > 480 && (
                        <CallToAction>
                            <button><FiShoppingCart size={16} /></button>
                            <ButtonIntegrador href="https://integrador.renovera.com.br/" target="blank_"><CiUser size={16} /> Área do integrador <IoIosArrowDown /></ButtonIntegrador>
                        </CallToAction>
                    )}

                    {screenWidth <= 480 && (
                        <>
                            <ButtonMenuMobile onClick={handleMenuMobile}><GiHamburgerMenu /></ButtonMenuMobile>
                        </>
                    )}
                </HeaderContainer>
            </GridContainer>
        </div>
    )
}